// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file featureflag/v1/feature_flag.proto (package featureflag.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_featureflag_v1_ext } from "./ext_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file featureflag/v1/feature_flag.proto.
 */
export const file_featureflag_v1_feature_flag: GenFile = /*@__PURE__*/
  fileDesc("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", [file_featureflag_v1_ext]);

/**
 * @generated from message featureflag.v1.FeatureFlag
 */
export type FeatureFlag = Message<"featureflag.v1.FeatureFlag"> & {
  /**
   * @generated from field: featureflag.v1.FeatureFlagKey key = 1;
   */
  key: FeatureFlagKey;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * JSON string for feature flag configuration
   *
   * @generated from field: string config = 4;
   */
  config: string;

  /**
   * Raw key string from DB, used for orphaned flags whose enum was removed
   *
   * @generated from field: string raw_key = 5;
   */
  rawKey: string;
};

/**
 * Describes the message featureflag.v1.FeatureFlag.
 * Use `create(FeatureFlagSchema)` to create a new message.
 */
export const FeatureFlagSchema: GenMessage<FeatureFlag> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 0);

/**
 * @generated from message featureflag.v1.ListFeatureFlagsRequest
 */
export type ListFeatureFlagsRequest = Message<"featureflag.v1.ListFeatureFlagsRequest"> & {
};

/**
 * Describes the message featureflag.v1.ListFeatureFlagsRequest.
 * Use `create(ListFeatureFlagsRequestSchema)` to create a new message.
 */
export const ListFeatureFlagsRequestSchema: GenMessage<ListFeatureFlagsRequest> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 1);

/**
 * @generated from message featureflag.v1.ListFeatureFlagsResponse
 */
export type ListFeatureFlagsResponse = Message<"featureflag.v1.ListFeatureFlagsResponse"> & {
  /**
   * @generated from field: repeated featureflag.v1.FeatureFlag feature_flags = 1;
   */
  featureFlags: FeatureFlag[];
};

/**
 * Describes the message featureflag.v1.ListFeatureFlagsResponse.
 * Use `create(ListFeatureFlagsResponseSchema)` to create a new message.
 */
export const ListFeatureFlagsResponseSchema: GenMessage<ListFeatureFlagsResponse> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 2);

/**
 * @generated from message featureflag.v1.UpdateFeatureFlagRequest
 */
export type UpdateFeatureFlagRequest = Message<"featureflag.v1.UpdateFeatureFlagRequest"> & {
  /**
   * @generated from field: featureflag.v1.FeatureFlagKey key = 1;
   */
  key: FeatureFlagKey;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string updated_by = 4;
   */
  updatedBy: string;

  /**
   * JSON string for feature flag configuration
   *
   * @generated from field: string config = 5;
   */
  config: string;
};

/**
 * Describes the message featureflag.v1.UpdateFeatureFlagRequest.
 * Use `create(UpdateFeatureFlagRequestSchema)` to create a new message.
 */
export const UpdateFeatureFlagRequestSchema: GenMessage<UpdateFeatureFlagRequest> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 3);

/**
 * @generated from message featureflag.v1.UpdateFeatureFlagResponse
 */
export type UpdateFeatureFlagResponse = Message<"featureflag.v1.UpdateFeatureFlagResponse"> & {
};

/**
 * Describes the message featureflag.v1.UpdateFeatureFlagResponse.
 * Use `create(UpdateFeatureFlagResponseSchema)` to create a new message.
 */
export const UpdateFeatureFlagResponseSchema: GenMessage<UpdateFeatureFlagResponse> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 4);

/**
 * @generated from message featureflag.v1.DeleteFeatureFlagRequest
 */
export type DeleteFeatureFlagRequest = Message<"featureflag.v1.DeleteFeatureFlagRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;
};

/**
 * Describes the message featureflag.v1.DeleteFeatureFlagRequest.
 * Use `create(DeleteFeatureFlagRequestSchema)` to create a new message.
 */
export const DeleteFeatureFlagRequestSchema: GenMessage<DeleteFeatureFlagRequest> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 5);

/**
 * @generated from message featureflag.v1.DeleteFeatureFlagResponse
 */
export type DeleteFeatureFlagResponse = Message<"featureflag.v1.DeleteFeatureFlagResponse"> & {
};

/**
 * Describes the message featureflag.v1.DeleteFeatureFlagResponse.
 * Use `create(DeleteFeatureFlagResponseSchema)` to create a new message.
 */
export const DeleteFeatureFlagResponseSchema: GenMessage<DeleteFeatureFlagResponse> = /*@__PURE__*/
  messageDesc(file_featureflag_v1_feature_flag, 6);

/**
 * @generated from enum featureflag.v1.FeatureFlagKey
 */
export enum FeatureFlagKey {
  /**
   * @generated from enum value: FEATURE_FLAG_KEY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEATURE_FLAG_KEY_DEBUG = 1;
   */
  DEBUG = 1,

  /**
   * @generated from enum value: FEATURE_FLAG_KEY_USE_FAKE_EEX = 8;
   */
  USE_FAKE_EEX = 8,

  /**
   * Reserved: FEATURE_FLAG_KEY_JERA_FLOATING_INDEX = 16
   * Reserved: FEATURE_FLAG_KEY_PFE_PEAK_MC_NEXT_EVALUATION = 17
   * Reserved: FEATURE_FLAG_KEY_MTM_DROP_AT_PAYMENT_DATE = 20
   * Reserved: FEATURE_FLAG_KEY_BILATERAL_VM_EXCHANGE = 21
   * Reserved: FEATURE_FLAG_KEY_PFE_EXPOSURE_PERIOD_BEFORE_PAYMENT_DATE = 22
   * Reserved: FEATURE_FLAG_KEY_IGNORE_WITH_FLOATING_INDEX = 23
   * Reserved: FEATURE_FLAG_KEY_USE_SPAN_V2 = 26
   * emodel serviceを使ってMTM計算を行う
   *
   * @generated from enum value: FEATURE_FLAG_KEY_USE_EMODEL_MTM = 24;
   */
  USE_EMODEL_MTM = 24,

  /**
   * EOD処理でVM相互差し入れ(bilateral)のマージンコール判定・入出金予定作成を有効化する
   *
   * @generated from enum value: FEATURE_FLAG_KEY_EOD_BILATERAL_MARGIN_CALL = 36;
   */
  EOD_BILATERAL_MARGIN_CALL = 36,

  /**
   * 預託金統合モデル(Ver9.1)を本番PFEの担保後処理に適用する。
   * ON ならマージンコールサービス対象の全組織で csa_type が CSA_TYPE_BILATERAL になる。
   * 入力は契約の形によらず同じ（仮想口座残高の seed・fresh IM・契約 mta/eclear_mta・cashIO は
   * 預託金口座の入出金予定）で、違いは counterparty_only（片務 = true）だけ。顧客預託金の返却はなし。
   * OFF は従来の CSA_TYPE_CALL_ONLY（判定日に前営業日の値を使う旧モデル）で、片務組織は seed も取得しない。
   * 流動性キャッシュフローレポートの PE 行（liquidity_pe_99_2m / liquidity_pe_60_1m）もこのフラグで切り替わる:
   * ON なら預託金統合モデルで計算した全社流動性PFE（calculate-liquidity-pfe の run、基準日当日のものだけ。
   * 無ければ warn して PE 行なし）、OFF なら旧 get-liquidity-pfe の行列から作る。日配置と 0 床は同じ。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_USE_BILATERAL_VM_PFE = 42;
   */
  USE_BILATERAL_VM_PFE = 42,

  /**
   * 簡易口のdeal登録でengine発番の成約コードをplatform_deal_idとして指定する
   *
   * @generated from enum value: FEATURE_FLAG_KEY_ENABLE_ENGINE_DEAL_ID = 43;
   */
  ENABLE_ENGINE_DEAL_ID = 43,

  /**
   * マージンコール(BANK_TRANSACTION_USAGE_TYPE_MARGIN_CALL)の入出金予定に対して
   * クリアラー入出金予定を生成しない。VM相互差入の対象・非対象を問わず一律で適用する。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_SKIP_CLEARER_TRANSACTION_FOR_MARGIN_CALL = 45;
   */
  SKIP_CLEARER_TRANSACTION_FOR_MARGIN_CALL = 45,

  /**
   * eClear の新しいマッチングプロセス(eposition-backend module)を使う。
   *
   * ON のとき次の 3 つを切り替える:
   *
   *   - ブローカーの簡易口と開発用のポスティングシミュレーターから登録する約定を、新しい登録経路 (RegisterDeal) に通す。
   *     OFF なら既存の二相の登録 (CreateDeal → CaptureDeal)。
   *   - 契約内容控えの発行 API (internalapi.v1.RecapService/IssueRecap) が、記録の後に
   *     暫定のイベント (eposition.clearing.recap.v1.RecapIssuedEvent) を発行する。OFF なら控えの記録だけ行う。
   *   - 既存の機能による約定のアーカイブ (約定削除など) を、新しい側に知らせる。OFF なら知らせない。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_USE_CLEARING_MATCHING_PROCESS = 49;
   */
  USE_CLEARING_MATCHING_PROCESS = 49,

  /**
   * 特種取引の入力欄を画面に出す。
   *
   *   - Broker 約定登録 (簡易口): OFF の間は組織欄の「特種取引」チェックボックスを出さず、
   *     送信値にも is_special_trade を載せない。
   *   - 約定詳細 (Broker / Admin) の特種取引バッジは登録済みデータの表示なので、このフラグでは隠さない。
   *
   * backend はこのフラグを見ない (API は is_special_trade を常に受け付ける)。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_ENABLE_SPECIAL_TRADE_INPUT = 50;
   */
  ENABLE_SPECIAL_TRADE_INPUT = 50,

  /**
   * 現先スプレッドの交換側にも基本手数料を請求し、同限月スプレッドの金利コストの上乗せを +0.01 にする。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_CHARGE_SPREAD_EXCHANGE_LEG_FEE = 51;
   */
  CHARGE_SPREAD_EXCHANGE_LEG_FEE = 51,

  /**
   * eposition-backend（新しいクリアリングのモジュール）が、約定の処理状況が変わったことの合図
   * （eposition.clearing.dealprocessing.v1.DealProcessingChangedEvent）を service-posting 向けのトピックへ出す。
   *
   *   - OFF の間、送り手は合図を出さない。合図待ちの記録は flag によらず書くので、ON にしたときに溜まった分をまとめて出す。
   *   - トピック名の設定が空なら、flag によらず送り手は組み込まれない。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_PUBLISH_DEAL_PROCESSING_CHANGED = 52;
   */
  PUBLISH_DEAL_PROCESSING_CHANGED = 52,

  /**
   * IM（SPAN V2）のスプレッドクレジットを v1.1 の方式で計算する。
   *
   *   - ON: 向きが逆のペアだけにクレジットを付ける方式（v1.1、OPPOSITE_DIRECTION）を計算エンジンに依頼する。
   *   - OFF: 数量の絶対値でペアを組む今の方式（v1.0、ABSOLUTE_QUANTITY）を明示して依頼する。
   *
   * 約定ごとの与信判定（legacy・eposition-backend）、日次の IM、devtool の IM 計算（画面が方式を指定しないとき）の
   * 全部が同じ値を見る。切り替えは日次の処理が終わった後から翌営業日の取引の前までに行う。
   *
   * @generated from enum value: FEATURE_FLAG_KEY_USE_IM_OPPOSITE_DIRECTION_SPREAD_CREDIT = 53;
   */
  USE_IM_OPPOSITE_DIRECTION_SPREAD_CREDIT = 53,
}

/**
 * Describes the enum featureflag.v1.FeatureFlagKey.
 */
export const FeatureFlagKeySchema: GenEnum<FeatureFlagKey> = /*@__PURE__*/
  enumDesc(file_featureflag_v1_feature_flag, 0);

/**
 * @generated from service featureflag.v1.FeatureFlagService
 */
export const FeatureFlagService: GenService<{
  /**
   * @generated from rpc featureflag.v1.FeatureFlagService.ListFeatureFlags
   */
  listFeatureFlags: {
    methodKind: "unary";
    input: typeof ListFeatureFlagsRequestSchema;
    output: typeof ListFeatureFlagsResponseSchema;
  },
  /**
   * @generated from rpc featureflag.v1.FeatureFlagService.UpdateFeatureFlag
   */
  updateFeatureFlag: {
    methodKind: "unary";
    input: typeof UpdateFeatureFlagRequestSchema;
    output: typeof UpdateFeatureFlagResponseSchema;
  },
  /**
   * @generated from rpc featureflag.v1.FeatureFlagService.DeleteFeatureFlag
   */
  deleteFeatureFlag: {
    methodKind: "unary";
    input: typeof DeleteFeatureFlagRequestSchema;
    output: typeof DeleteFeatureFlagResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_featureflag_v1_feature_flag, 0);

